var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex"},[(_vm.isFa)?_c('div',{staticClass:"logo-container"},[_c('font-awesome-icon',{staticClass:"d-flex icon-fa",style:({
        color: _vm.formattedIcon.color,
        fontSize: _vm.size + 'px',
      }),attrs:{"icon":[_vm.iconStyle, _vm.formattedIcon.value]}})],1):(_vm.isImage)?_c('div',{staticClass:"logo-container"},[_c('img',{style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":_vm.formattedIcon.value}})]):(_vm.isEmoji)?_c('div',{staticClass:"logo-container"},[_vm._v(" "+_vm._s(_vm.formattedIcon.value)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }